<template>
  <v-navigation-drawer
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    width="280"
    v-bind="$attrs"
    class="modern-drawer"
    id="core-navigation-drawer"
  >
    <!-- Header Section -->
    <div class="drawer-header">
      <div class="header-background"></div>
      <div class="header-content">
        <div class="logo-container">
          <v-img 
            src="hrvec.png" 
            height="80" 
            contain 
            class="logo-image"
          />
        </div>
        <div class="system-title">     
          <p class="title-sub">ระบบบริหารงานบุคคล</p>
        </div>
      </div>
    </div>

    <v-divider class="header-divider" />

    <!-- Navigation Menu -->
    <div class="navigation-content">
      <v-list class="nav-list" nav>
        <template v-for="(item, i) in computedItems">
          <base-item-group 
            v-if="item.children" 
            :key="`group-${i}`" 
            :item="item"
            class="nav-group"
          />

          <base-item 
            v-else 
            :key="`item-${i}`" 
            :item="item"
            class="nav-item"
          />
        </template>  
      </v-list>
    </div>

    <!-- Footer Action -->
    <template v-slot:append>
      <div class="drawer-footer">
        <base-item
          :item="{
            title: 'เข้าสู่ระบบสำหรับสถานศึกษา',
            icon: 'mdi-login',
            to: '/pages/login'
          }"
          class="footer-item"
        />
        
        <!-- Quick Info Card -->
        <v-card class="info-card mt-3 mx-3 mb-3" elevation="2" v-if="showQuickInfo">
          <v-card-text class="pa-3">
            <div class="quick-info">
              <v-icon small color="info" class="mr-2">mdi-information</v-icon>
              <div class="info-content">
                <div class="info-title">สถานะระบบ</div>
                <div class="info-text">ปกติ</div>
              </div>
              <v-icon small color="success">mdi-check-circle</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    ApiKey: "HRvec2021",
    showQuickInfo: true,
    items: [
      {
        icon: "mdi-view-dashboard",
        title: "ข้อมูลทั่วไป",
        to: "/",
        color: "primary"
      },
      {
        title: "สถานศึกษา",
        icon: "mdi-school",
        to: "/pages/colleges",
        color: "success"
      },
       {
        title: "สถิตินักเรียน นักศึกษา",
        icon: "mdi-school",
        to: "/pages/std_vec",
        color: "success"
      },
      {
        title: "สถิติข้อมูลลูกเสือวิสามัญ",
        icon: "mdi-tent",
        to: "/pages/personnel_scout_report",
        color: "success"
      },
      {
        title: "ข่าวประชาสัมพันธ์และคู่มือ",
        icon: "mdi-bell",
        to: "/news",
        color: "orange"
      },
 
       {
        title: "ค้นหาข้อมูลบุคคลากร",
        icon: "mdi-magnify",
        to: "/pages/personnel_search",
        color: "green"
      },

      {
        title: "เข้าสู่ระบบ",
        icon: "mdi-login",
        to: "/pages/login",
        color: "info"
      }
    ],
    itemsAssistant: [
      {
        title: "เรียกบรรจุครูผู้ช่วย",
        icon: "mdi-account-tie",
        to: "/pages/loginAssTeach",
        color: "purple"
      }
    ],
    periodassteachs: {},
    periodAssTeachEnable: "1",
      seting_sys: []

  }),

  async mounted() {
    await this.seting_sysQuery();

    await this.fetchAssistantTeacherStatus();
  },

  computed: {
    ...mapState(["barColor", "barImage"]),
    
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    },
    
    computedItems() {
      return this.items.map(this.mapItem);
    },
    
    showAssistantTeacher() {
      return this.periodassteachs && Object.keys(this.periodassteachs).length > 0;
    },
    
    profile() {
      return {
        avatar: true,
        title: "HRvec IPA"
      };
    }
  },

  methods: {
    async seting_sysQuery() {
      let result = await this.$http.post("seting_sys.php", {
        ApiKey: "HRvec2021",
        seting_sys_id: "1"
      });
      this.seting_sys = result.data;
    },

    async fetchAssistantTeacherStatus() {
      try {
        const result = await this.$http.post("periodassteach.php", {
          ApiKey: this.ApiKey,
          periodAssTeachEnable: this.periodAssTeachEnable
        });
        this.periodassteachs = result.data || {};
      } catch (error) {
        console.error('Error fetching assistant teacher status:', error);
        this.periodassteachs = {};
      }
    },

    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t ? this.$t(item.title) : item.title
      };
    },

    handleItemClick(item) {
      // Handle navigation or custom actions
      if (item.to) {
        this.$router.push(item.to);
      }
    }
  }
};
</script>

<style scoped>

/* Modern Drawer Styling */
.modern-drawer {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1) !important;
}

/* Header Section */
.drawer-header {
  position: relative;
  padding: 2rem 1.5rem 1.5rem;
  overflow: hidden;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;  
  pointer-events: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.logo-container {
  text-align: center;
  margin-bottom: 1rem;
}

.logo-image {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 0.5rem;
}

.system-title {
  text-align: center;
}

.title-main {
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
}

.title-sub {
  font-size: 0.9rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 400;
}

.header-divider {
  border-color: rgba(0, 0, 0, 0.08) !important;
  margin: 0;
}

/* Navigation Content */
.navigation-content {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 0;
}

.nav-list {
  padding: 0 !important;
}

/* Navigation Items */
.nav-item {
  margin: 0 1rem 0.5rem 1rem;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

.nav-item:hover {

  transform: translateX(4px);
}

.nav-item.v-list-item--active {
  background: rgba(43, 108, 176, 0.1) !important;
  color: #2b6cb0 !important;
  border-left: 4px solid #3182ce;
}

/* Section Styling */
.section-divider {
  margin: 1.5rem 1rem;
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.section-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  margin: 0.5rem 1rem;
  background: rgba(43, 108, 176, 0.05);
  border-radius: 10px;
  border-left: 3px solid #2b6cb0;
}

.section-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #2b6cb0;
}

.assistant-item {
  background: rgba(156, 39, 176, 0.03) !important;
  border-left: 3px solid transparent;
}

.assistant-item:hover {
  background: rgba(156, 39, 176, 0.08) !important;
  border-left-color: #9c27b0;
}

/* Footer */
.drawer-footer {
  padding: 1rem;
  background: linear-gradient(180deg, transparent 0%, rgba(248, 250, 252, 0.5) 100%);
}

.footer-item {
  margin-bottom: 0.5rem;
  border-radius: 12px !important;
  background: #2b6cb0 !important;
  color: white !important;
}

.footer-item:hover {
  background: #2c5282 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(43, 108, 176, 0.35);
}

/* Info Card */
.info-card {
  border-radius: 12px !important;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9) !important;
  border: 1px solid rgba(43, 108, 176, 0.1);
}

.quick-info {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
}

.info-content {
  flex: 1;
  margin-left: 0.5rem;
}

.info-title {
  font-weight: 600;
  color: #ffffff;
  line-height: 1.2;
}

.info-text {
  color: #718096;
  font-size: 0.75rem;
}

/* Responsive Design */
@media (max-width: 960px) {
  .drawer-header {
    padding: 1.5rem 1rem 1rem;
  }
  
  .title-main {
    font-size: 1.1rem;
  }
  
  .title-sub {
    font-size: 0.8rem;
  }
  
  .nav-item {
    margin: 0 0.5rem 0.5rem 0.5rem;
  }
  
  .section-header {
    margin: 0.5rem 0.5rem;
    padding: 0.5rem 1rem;
  }
}

/* Animation Effects */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.nav-item {
  animation: slideInLeft 0.3s ease-out;
}

.nav-item:nth-child(1) { animation-delay: 0.1s; }
.nav-item:nth-child(2) { animation-delay: 0.2s; }
.nav-item:nth-child(3) { animation-delay: 0.3s; }
.nav-item:nth-child(4) { animation-delay: 0.4s; }

/* Custom Scrollbar */
.navigation-content::-webkit-scrollbar {
  width: 4px;
}

.navigation-content::-webkit-scrollbar-track {
  background: transparent;
}

.navigation-content::-webkit-scrollbar-thumb {
  border-radius: 2px;
}



/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .modern-drawer {
    border-right-color: rgba(255, 255, 255, 0.1) !important;
  }
  

  .nav-item:hover {
    background: rgba(43, 108, 176, 0.2) !important;
  }
  
  .info-card {
    background: linear-gradient(135deg, #2d3748, #4a5568) !important;
    border-color: rgba(43, 108, 176, 0.2);
  }   
}

/* Focus states for accessibility */
.nav-item:focus {
  outline: 2px solid #2b6cb0;
  outline-offset: 2px;
}

.footer-item:focus {
  outline: 2px solid white;
  outline-offset: 2px;
}

/* Hover animations */
.nav-item .v-list-item__icon {
  transition: transform 0.3s ease;
}

.nav-item:hover .v-list-item__icon {
  transform: scale(1.1);
}

/* Logo hover effect */
.logo-image {
  transition: all 0.3s ease;
}

.logo-container:hover .logo-image {
  transform: scale(1.05);
  background: rgba(255, 255, 255, 0.15);
}
</style>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px

  // Modern enhancements
  .v-list-item
    border-radius: 12px !important
    margin: 0 1rem 0.5rem 1rem
    
    &__content
      padding: 8px 0
    
    &__title
      font-weight: 500
      font-size: 0.9rem
    
    &__icon
      color: inherit !important
</style>